import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-empty-pdr-data',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './empty-pdr-data.component.html',
  styleUrl: './empty-pdr-data.component.css'
})
export class EmptyPdrDataComponent {
  @Input() vat = '';
}
